var stickerSupportedElements = ['defs', 'circle', 'image', 'ellipse', 'line', 'rect', 'text', 'polygon', 'path', 'g'];

module.exports = function (svg) {
  var g, $children = $(svg).children();

  if (isAlreadyGrouped($children)) {
    g = $children.get(0);
  } else {
    g = document.createElementNS(svgedit.NS.SVG, 'g');
    cleanGroupChild(svg, g);
  }

  setAttributes(g);

  return g;
};

function isAlreadyGrouped ($children) {
  return $children.length == 1
    && $children.get(0).tagName == 'g'
    && !$children.get(0).getAttribute('class');
}

function setAttributes (g) {
  var editor = INKIVE.Tool.getInstance().editor;

  g.setAttribute('class', 'element sticker');
  g.setAttribute('id', editor.getNextId());
}

function cleanGroupChild (svg, g) {
  var len = svg.childNodes.length;

  for (var i = len - 1; i >= 0; i--) {
    var elem = svg.childNodes[i];

    if (_.contains(stickerSupportedElements, svg.childNodes[i].tagName)) {
      g.insertBefore(elem, g.firstChild);
    }
  }
}
